import { jsx as s } from "react/jsx-runtime";
import a from "react";
import { clsx as d } from "clsx";
const m = ({ children: e, className: t, id: o }) => {
  const i = a.useId(), r = o ?? i;
  return /* @__PURE__ */ s("div", { className: d(t), "data-testid": "box-element", id: r, children: e });
};
m.displayName = "Box";
export {
  m as B
};
